export default __webpack_public_path__ + "static/media/back-2.911a8d0b.png";